import { render, staticRenderFns } from "./photo-signup.vue?vue&type=template&id=74c5b46c&scoped=true"
import script from "./photo-signup.vue?vue&type=script&lang=ts"
export * from "./photo-signup.vue?vue&type=script&lang=ts"
import style0 from "./photo-signup.vue?vue&type=style&index=0&id=74c5b46c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c5b46c",
  null
  
)

export default component.exports